/**
 * <image-logo-list> — sections/image-with-logo-list.liquid
 * Mobile swipe cards over the image: syncs the progress bar with the native
 * scroll-snap track, and scrolls to a card when a block is selected in the
 * theme editor.
 */
(function () {
  if (customElements.get("image-logo-list")) return;

  const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

  class ImageLogoList extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector("[data-iwl-track]");
      if (!this.track) return;

      this.slides = Array.from(this.track.querySelectorAll("[data-iwl-slide]"));
      this.progress = this.querySelector("[data-iwl-progress]");
      this.activeIndex = 0;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.track.addEventListener("scroll", this.onScroll, { passive: true });
      document.addEventListener("shopify:block:select", this.onBlockSelect);
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener("scroll", this.onScroll);
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.setActive(this.getClosestIndex());
      });
    }

    // Slide whose left edge is nearest the track's snap start
    getClosestIndex() {
      const trackLeft =
        this.track.getBoundingClientRect().left +
        parseFloat(getComputedStyle(this.track).paddingLeft || 0);
      let closest = 0;
      let minDistance = Infinity;

      this.slides.forEach((slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closest = index;
        }
      });

      // Last card may never reach the snap start when scrolled to the end
      const atEnd =
        Math.abs(this.track.scrollWidth - this.track.clientWidth - Math.abs(this.track.scrollLeft)) < 2;
      return atEnd ? this.slides.length - 1 : closest;
    }

    setActive(index) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;
      if (this.progress) {
        this.progress.style.transform = `scaleX(${(index + 1) / this.slides.length})`;
      }
    }

    goTo(index) {
      const slide = this.slides[index];
      if (!slide) return;

      const reduceMotion = window.matchMedia(REDUCED_MOTION_QUERY).matches;
      const offset = slide.offsetLeft - parseFloat(getComputedStyle(this.track).paddingLeft || 0);
      this.track.scrollTo({ left: offset, behavior: reduceMotion ? "auto" : "smooth" });
      this.setActive(index);
    }

    onBlockSelect(event) {
      const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (index !== -1) this.goTo(index);
    }
  }

  customElements.define("image-logo-list", ImageLogoList);
})();
